module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Electric/air-dryer-5a06c8f4e22f897af558f13412c61538.svg";